import { TriangleExclamationIcon } from '@village/icons';
import { useId } from 'react';
import { Path, useController } from 'react-hook-form';

import * as Styled from './styles';

interface Props<FormSchema> {
    id?: string;
    label: string;
    name: Path<FormSchema>;
    options: { label: string; value: string }[];
    disabled?: boolean;
}

const RadioForm = <FormSchema,>({ name, options, label, id, disabled }: Props<FormSchema>) => {
    const { field, fieldState } = useController({ name });
    const generatedId = useId();
    const radioId = id ?? generatedId;
    const hasError = Boolean(fieldState.error);

    return (
        <div data-role="radiogroup" aria-labelledby={radioId} aria-invalid={hasError}>
            <Styled.Label id={radioId} type="caption1" tag="label">
                {label}
            </Styled.Label>
            <Styled.RadioValuesContainer $hasError={hasError}>
                {options.map((option) => (
                    <Styled.RadioInput
                        aria-selected={field.value === option.value}
                        key={option.value}
                        label={option.label}
                        {...field}
                        value={option.value}
                        checked={field.value === option.value}
                        disabled={disabled}
                    />
                ))}
            </Styled.RadioValuesContainer>
            {hasError ? (
                <Styled.ErrorContainer type="caption2">
                    <TriangleExclamationIcon size="sm" />
                    {fieldState.error?.message}
                </Styled.ErrorContainer>
            ) : null}
        </div>
    );
};

export { RadioForm };
